import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideLead,
  GuideCallout,
  GuideCompare,
  GuideBlockList,
  GuideContrast,
} from "../GuideBlocks.js";

const RespondVsReactSection = ({ heading, accentIndex = 1, getVisual, getAccent }) => (
  <GuidePanel
    sectionId="respond-vs-react"
    heading={heading}
    accentIndex={accentIndex}
    getVisual={getVisual}
    getAccent={getAccent}
  >
    <GuideLead>
      When emotions become strong, we often react automatically. Reaction is immediate. Response is
      intentional.
    </GuideLead>
    <GuideContrast
      items={[
        { title: "Reaction is driven by emotion.", text: "It happens before you pause to think." },
        { title: "Response is guided by awareness.", text: "It follows deliberate consideration." },
      ]}
    />
    <p className="guide-panel__p">
      A delayed email might trigger frustration. The event remains the same. Your response changes the
      outcome.
    </p>
    <GuideCompare
      leftTitle="Reaction"
      rightTitle="Response"
      left={
        <GuideBlockList
          items={[
            "Sending an angry follow-up.",
            "Making negative assumptions.",
            "Complaining to others.",
          ]}
        />
      }
      right={
        <GuideBlockList
          items={[
            "Waiting a reasonable amount of time.",
            "Sending a polite reminder.",
            "Calling if the matter is urgent.",
            "Considering alternative explanations.",
          ]}
        />
      }
    />
    <GuideCallout variant="amber">
      Structured thinking inserts a pause between the event and your action. That pause is where
      better decisions are made.
    </GuideCallout>
  </GuidePanel>
);

export default RespondVsReactSection;
